export default "__VITE_ASSET__06e5a39b__"